import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';
import { CareProductType } from '../enums/careProductType';
import { positiveInt32Schema } from './schemas/positiveInt32Schema';

export interface INzaServiceDeclarationSettingAddEditValidated {
    careProductType: CareProductType;
    declarationCode: string | null;
    endDate: Date | null;
    nzaServiceDeclarationRuleId: string;
    price: number;
    startDate: Date;
}

const nzaServiceDeclarationSettingEdit = Koi.object({
    careProductType: Koi.koi().enum(CareProductType),
    declarationCode: Koi.string().min(6).max(6).allow(null),
    endDate: Koi.koi().date().endDate().allow(null),
    price: Koi.when('declarationCode', {
        is: Koi.string(),
        otherwise: positiveInt32Schema.allow(null),
        then: positiveInt32Schema.required(),
    }),
    startDate: Koi.koi().date(),
}).options({ convert: false, presence: 'required' });

export const nzaServiceDeclarationSettingEditSchema: ISchemaContainer<INzaServiceDeclarationSettingAddEditValidated> = {
    schema: nzaServiceDeclarationSettingEdit,
};

export const nzaServiceDeclarationSettingAddSchema: ISchemaContainer<INzaServiceDeclarationSettingAddEditValidated> = {
    schema: nzaServiceDeclarationSettingEdit.concat(
        Koi.object({
            nzaServiceDeclarationRuleId: Koi.string().uuid(),
        }).options({ convert: false, presence: 'required' })
    ),
};
